import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {MiniDashboardLayout} from './miniDashboardLayout/MiniDashboardLayout';
import {MiniDashboardLayout as NWayMiniDashboardLayout} from '../../nwayDashboard/components/layouts/miniDashboardLayout/MiniDashboardLayout';
import {inject, IReactComponent, observer} from 'mobx-react';
import {MultipartyDashboardController} from '../../MultipartyDashboardController';
import {MultipartyDashboardController as NWayMultipartyDashboardController} from '../../nwayDashboard/MultipartyDashboardController';
import {LiveDashboardLayout} from './liveDashboardLayout/LiveDashboardLayout';
import {LiveDashboardLayout as NWayLiveDashboardLayout} from '../../nwayDashboard/components/layouts/liveDashboardLayout/LiveDashboardLayout';

type MultipartyDashboardLayoutProps = {
    controller: MultipartyDashboardController | NWayMultipartyDashboardController;
    // The controller can be either a standard MultipartyDashboardController or an NWayMultipartyDashboardController
    // This allows the component to handle both types of controllers
};

@observer
export class MultipartyDashboardLayout extends TechseeBaseComponent<MultipartyDashboardLayoutProps> {
    renderInternal(): JSX.Element {
        const {controller} = this.props;

        if (controller instanceof NWayMultipartyDashboardController) {
            return controller.miniDashboard ? (
                <NWayMiniDashboardLayout controller={controller} />
            ) : (
                <NWayLiveDashboardLayout controller={controller} />
            );
        } else {
            return controller.miniDashboard ? (
                <MiniDashboardLayout controller={controller} />
            ) : (
                <LiveDashboardLayout controller={controller} />
            );
        }
    }
}

const mapStoresToProps = (stores: any) => ({
    controller: stores.multipartyDashboardStore.dashboardController
});

export const DashboardContainer = inject(mapStoresToProps)(MultipartyDashboardLayout) as IReactComponent;
